import { GET_LINEN_INVENTORY_FOR_GROUP_FAILURE, GET_LINEN_INVENTORY_FOR_GROUP_SUCCESS } from '../constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case GET_LINEN_INVENTORY_FOR_GROUP_SUCCESS:
            return onSuccess(state, action);
        case GET_LINEN_INVENTORY_FOR_GROUP_FAILURE:
            return onFailure(state, action);
        default:
            return { ...state };
    }
};
